import { DatePicker, DatePickerInput } from '@carbon/react';

function formatIsoDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const CarbonDateField = ({
  id,
  labelText,
  value,
  onChange,
  placeholder = 'yyyy-mm-dd',
  minDate,
  maxDate,
  hideLabel = false,
}) => (
  <DatePicker
    datePickerType="single"
    dateFormat="Y-m-d"
    value={value || undefined}
    minDate={minDate || undefined}
    maxDate={maxDate || undefined}
    onChange={(dates) => {
      onChange(dates?.[0] ? formatIsoDate(dates[0]) : '');
    }}
  >
    <DatePickerInput
      id={id}
      labelText={labelText}
      hideLabel={hideLabel}
      placeholder={placeholder}
    />
  </DatePicker>
);

export default CarbonDateField;
